<template>
  <div></div>
</template>
<script>
import { mapGetters } from "vuex"
import { USER_GET } from "@/store/types"
export default {
  computed: {
    ...mapGetters(["getCurrentUser"])
  },
  watch: {
    "$route.name": {
      async handler(val) {
        let reload = false

        if (val) {
          if (val.includes("apply_")) {
            this.grooveId = this.grooveWidgetApplicant
          } else {
            if (!this.getCurrentUser) {
              try {
                await this.$store.dispatch(USER_GET)
                if (this.getCurrentUser.landlord) {
                  reload = this.loaded && this.grooveId !== this.grooveWidgetLandlord
                  this.grooveId = this.grooveWidgetLandlord
                } else if (this.getCurrentUser.applicant) {
                  reload = this.loaded && this.grooveId !== this.grooveWidgetApplicant
                  this.grooveId = this.grooveWidgetApplicant
                } else {
                  reload = this.loaded && this.grooveId !== this.grooveWidgetProspect
                  this.grooveId = this.grooveWidgetProspect
                }
              } catch (err) {
                reload = this.loaded && this.grooveId !== this.grooveWidgetProspect
                this.grooveId = this.grooveWidgetProspect
              }
            } else {
              if (this.getCurrentUser.landlord) {
                reload = this.loaded && this.grooveId !== this.grooveWidgetLandlord
                this.grooveId = this.grooveWidgetLandlord
              } else if (this.getCurrentUser.applicant) {
                reload = this.loaded && this.grooveId !== this.grooveWidgetApplicant
                this.grooveId = this.grooveWidgetApplicant
              } else {
                reload = this.loaded && this.grooveId !== this.grooveWidgetProspect
                this.grooveId = this.grooveWidgetProspect
              }
            }
          }
          if ((!this.loaded && !this.$route.query.iframe) || reload) {
            this.loadGrooveScript()
          }
        }
      },
      immediate: true,
      deep: true
    }
  },
  data() {
    return {
      grooveId: null,
      loaded: false
    }
  },
  mounted() {},
  methods: {
    loadGrooveScript() {
      if (window.groove.widget) {
        window.groove.widget.destroy()
      }
      window.groove.widget = window.groove.createWidget()
      window.groove.widget.init(this.grooveId, {})
      this.loaded = true
    }
  }
}
</script>
